
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { ColorItem, ColorPalette, Meta } from '@storybook/addon-docs';
import tokens from '../compiled/tokens/js/tokens.js';
const generateColorPalette = (props) => {
  const propsArray = Object.values(props);
  return (
    <ColorPalette>
      {propsArray.map((prop) => (
        <ColorItem
          key={prop.name}
          title={`color.$${prop.name.slice(6)}`}
          subtitle={prop.comment}
          colors={[prop.value]}
        />
      ))}
    </ColorPalette>
  );
};
const brandColorPalette = generateColorPalette(tokens.color.brand);
const baseColorPalette = generateColorPalette(tokens.color.base);
const textColorPalette = generateColorPalette(tokens.color.text);


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Design/Tokens/Color" mdxType="Meta" />
    <h1>{`Color`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-scss"
      }}>{`@use '../../compiled/tokens/scss/color';
$example: color.$text-dark; // => rgba(0, 0, 0, 0.85)
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import tokens from '../../compiled/tokens/js/tokens';
console.log(tokens.color.text.dark.value); // => "rgba(0, 0, 0, 0.85)"
`}</code></pre>
    <h2>{`Text Color`}</h2>
    <>{textColorPalette}</>
    <h2>{`Primary Color`}</h2>
    <>{brandColorPalette}</>
    <h2>{`Color`}</h2>
    <>{baseColorPalette}</>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const __page = () => { throw new Error("Docs-only story"); };

__page.parameters = { docsOnly: true };

const componentMeta = { title: 'Design/Tokens/Color', includeStories: ["__page"],  };

const mdxStoryNameToKey = {};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;